var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProductGroupInfo2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 126,
    viewBox: "0 0 124 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0771 75V109.692H78.9233V75H41.0771Z",
    fill: "#D23778"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 75.1725L78.8077 69H87.6154L78.6831 75.4318L70 75.1725Z",
    fill: "#D23778"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6152 75.1725L40.8075 69H31.9998L40.9322 75.4318L49.6152 75.1725Z",
    fill: "#D23778"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3848 81.3077H53.6925V93.9231L60.0002 87.6154L66.3078 93.9231V81.3077H72.6155V103.385H47.3848V81.3077Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 40.5,
    r: 13.5,
    fill: "#FF64A5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 29.5,
    r: 13.5,
    fill: "#FF64A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 23V26.9H92.3077V34.7H91V36H92.3077H97.5385V34.7V31.45C97.5385 30.3749 98.4185 29.5 99.5 29.5C100.581 29.5 101.462 30.3749 101.462 31.45V34.7V36H106.692H108V34.7H106.692V26.9H108V23H91ZM92.3077 24.3H106.692V25.6H92.3077V24.3ZM93.6154 26.9H105.385V34.7H102.769V31.45C102.769 29.658 101.303 28.2 99.5 28.2C97.6973 28.2 96.2308 29.658 96.2308 31.45V34.7H93.6154V26.9Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8182 33C28.6222 33 27.6364 33.9036 27.6364 35C27.6364 36.0964 28.6222 37 29.8182 37C31.0142 37 32 36.0964 32 35C32 33.9036 31.0142 33 29.8182 33ZM18.5322 33L17.7031 34.0719L22.2297 37.1615C22.1513 37.2403 22.0588 37.3138 21.9832 37.3926C21.0532 38.3463 21.2409 39.8911 22.3866 40.6083L25.0308 42.2477L22.2969 43.7609L16.7171 40.7554L16 41.9324L28.5714 48.7C28.5938 48.7079 28.6162 48.7158 28.6387 48.7211C28.6387 48.7211 29.1457 48.9522 29.8039 48.9943C30.4622 49.0363 31.3978 48.8577 32 48.0905L30.8571 47.2919C30.5938 47.6281 30.2885 47.6728 29.916 47.6492C29.5798 47.6281 29.3417 47.5441 29.2885 47.5231L29.2213 47.502L23.7087 44.5386L25.7479 43.4036C26.6303 42.9124 26.6695 41.6697 25.8151 41.1338L23.1933 39.4944C22.7535 39.2185 22.6807 38.6616 23.0364 38.2964C23.4146 37.9076 23.8347 37.4899 24.2241 37.1404C24.7843 36.636 25.521 36.4048 26.1064 36.2997C26.2633 36.2708 26.3753 36.3707 26.3753 36.5309L26.3978 39.2212V39.5364L26.6891 39.7466L29.535 41.7853L30.409 40.7344L27.8319 38.8849L27.8095 36.5309C27.8039 35.5615 26.8431 34.7891 25.8151 34.9756C25.0532 35.1149 24.0672 35.4275 23.2381 36.1736L18.5322 33ZM29.8182 34.3333C30.2273 34.3333 30.5455 34.625 30.5455 35C30.5455 35.375 30.2273 35.6667 29.8182 35.6667C29.4091 35.6667 29.0909 35.375 29.0909 35C29.0909 34.625 29.4091 34.3333 29.8182 34.3333Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.704872
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.2402 50.3957L68.2402 56.3957L62.2402 50.3957",
    stroke: "#FF64A5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2402 32.3957C73.6128 32.3957 68.2402 37.7682 68.2402 44.3957V56.3957",
    stroke: "#FF64A5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.704872
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2402 62.3957L56.2402 68.3957L62.2402 62.3957",
    stroke: "#FF64A5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2402 44.3957C50.8677 44.3957 56.2402 49.7682 56.2402 56.3957V68.3957",
    stroke: "#FF64A5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProductGroupInfo2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/product-group-info-2.9ba19d11ab9e0ca69d2f03b3f140d585.svg";